// :cow: Cosmose CONFIDENTIAL :iso:
import { EnvironmentConfig } from '@med/app/core/config/environment-config';
import { config as mediaCosmoseCn } from '@med/app/core/config/configs/media.cosmose.cn';
import { config as mediaCosmoseCo } from '@med/app/core/config/configs/media.cosmose.co';
import { config as defaultConfig } from '@med/app/core/config/configs/default';
import { config as mediaDevCosmoseCloud } from '@med/app/core/config/configs/media.dev.cosmose.cloud';
import { config as mediaPreprodCosmoseCn } from '@med/app/core/config/configs/media.preprod.cosmose.cn';
import { config as mediaPreprodCosmoseCo } from '@med/app/core/config/configs/media.preprod.cosmose.co';
import { config as mediaPreviewCosmoseCn } from '@med/app/core/config/configs/media.preview.cosmose.cn';
import { config as mediaPreviewCosmoseCo } from '@med/app/core/config/configs/media.preview.cosmose.co';

export const getConfig = (domain: string): EnvironmentConfig => {
  const configMap = {
    'media.cosmose.cn': mediaCosmoseCn,
    'media.cosmose.co': mediaCosmoseCo,
    'media.dev.cosmose.cloud': mediaDevCosmoseCloud,
    'media.preprod.cosmose.cn': mediaPreprodCosmoseCn,
    'media.preprod.cosmose.co': mediaPreprodCosmoseCo,
    'media.preview.cosmose.cn': mediaPreviewCosmoseCn,
    'media.preview.cosmose.co': mediaPreviewCosmoseCo,
  };

  return configMap[domain] ?? mediaDevCosmoseCloud;
};
